import { render, staticRenderFns } from "./PessoaInterfaceFtpForm.vue?vue&type=template&id=2fc1c0d2"
import script from "./PessoaInterfaceFtpForm.vue?vue&type=script&lang=js"
export * from "./PessoaInterfaceFtpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports